module.exports = __webpack_public_path__ + "static/media/free.7dfa274b.png";